import {
  Typography,
  Container,
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CardMedia,
  Grid,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import {
  DEFAULT_BLUE,
  DEFAULT_BUTTON_STYLE,
  DEFAULT_GOLD,
  instituteInfo,
} from "../../constant";
import ErrorField from "../../GeneralComponents/ErrorField/ErrorField";
import muslimManSilhouette from "../../../assets/muslim-man-silhouette.png";
import muslimWomanSilhouette from "../../../assets/muslim-woman-silhouette-a.png";
import Header from "../../GeneralComponents/Header/Header";

const cardMediaImgStyle = {
  height: 140,
  objectFit: "contain",
  backgroundColor: "lightgrey",
};

const validationSchema = Yup.object({
  name: Yup.string().required("Nom requis"),
  email: Yup.string().email("Invide format d'email").required("Email requis"),
  subject: Yup.string().required("Sujet requis"),
  message: Yup.string().required("Message requis"),
});

const ContactPage = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleSubmit = (values: any, { resetForm }: any) => {
    const { name, email, subject, message } = values;
    const subjectEncoded = encodeURIComponent(subject);
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\nSubject: ${subject}\nMessage: ${message}`
    );

    const mailtoLink = `mailto:${instituteInfo.gmail}?subject=Contact via site web: ${subjectEncoded}&body=${body}`;

    window.location.href = mailtoLink;

    resetForm();
  };

  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      <Header title="Contactez-nous" />
      <Typography variant="body1" align="center" sx={{ mb: 4 }}>
        Pour toute question ou renseignement, n'hésitez pas à nous contacter via
        les informations ci-dessous ou à nous envoyer un message.
      </Typography>
      <Grid container spacing={2} sx={{ my: 4 }}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardMedia
              component="img"
              image={muslimManSilhouette}
              alt="Muslim man silhouette"
              sx={cardMediaImgStyle}
            />
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Contact homme
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                <strong>Numéro de téléphone :</strong> {instituteInfo.number}
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                <strong>Adresse e-mail :</strong> {instituteInfo.gmail}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardMedia
              component="img"
              image={muslimWomanSilhouette}
              alt="Muslim woman silhouette"
              sx={cardMediaImgStyle}
            />
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Contact soeur
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                <strong>Numéro de téléphone :</strong>{" "}
                {instituteInfo.instituteNumberSister}
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                <strong>Adresse e-mail :</strong> {instituteInfo.gmail}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box sx={{ my: 4 }}>
        <Card>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              Envoyez-nous un message
            </Typography>
            <br />
            <Formik
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ values, handleChange, isSubmitting, touched, errors }) => (
                <Form>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 2,
                      width: "100%",
                    }}
                  >
                    <TextField
                      name="name"
                      label="Nom"
                      fullWidth
                      variant="outlined"
                      value={values.name}
                      onChange={handleChange}
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                    />

                    <TextField
                      name="email"
                      label="Email"
                      type="email"
                      fullWidth
                      variant="outlined"
                      value={values.email}
                      onChange={handleChange}
                      error={touched.email && Boolean(errors.email)}
                      helperText={touched.email && errors.email}
                    />

                    <FormControl
                      fullWidth
                      variant="outlined"
                      error={touched.subject && Boolean(errors.subject)}
                    >
                      <InputLabel id="subject-label">Sujet</InputLabel>
                      <Select
                        labelId="subject-label"
                        name="subject"
                        value={values.subject}
                        onChange={handleChange}
                        label="Sujet"
                      >
                        <MenuItem value="Demande Général">
                          Demande générale
                        </MenuItem>
                        <MenuItem value="Inscription">Inscription</MenuItem>
                        <MenuItem value="Support">Problème technique</MenuItem>
                        <MenuItem value="Commentaire">
                          Commentaire et Suggestion
                        </MenuItem>
                        <MenuItem value="Paiement">
                          Information sur le paiement
                        </MenuItem>
                        <MenuItem value="Remboursement">
                          Demande de remboursement
                        </MenuItem>
                        <MenuItem value="Autre">Autre</MenuItem>
                      </Select>
                      {touched.subject && <ErrorField name="subject" />}
                    </FormControl>

                    <TextField
                      name="message"
                      label="Message"
                      fullWidth
                      multiline
                      rows={4}
                      variant="outlined"
                      value={values.message}
                      onChange={handleChange}
                      error={touched.message && Boolean(errors.message)}
                      helperText={touched.message && errors.message}
                    />

                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={isSubmitting}
                      sx={{
                        width: "100%",
                        marginTop: "10px",
                        backgroundColor: DEFAULT_BLUE,
                        color: DEFAULT_GOLD,
                        ...DEFAULT_BUTTON_STYLE,
                      }}
                    >
                      {isSubmitting ? "Envoie..." : "Envoyer"}
                    </Button>
                  </Box>
                </Form>
              )}
            </Formik>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default ContactPage;
